import React from 'react';
import { Box, Typography, Link, Card, CardContent, Stack } from '@mui/material';
import { ANNUAL_REPORT_TECHNICAL_ASSISTANCE_FORM_URL } from '../../constants/annualReports';

interface ResourceItem {
  href: string;
  label: string;
  description?: string;
}

const ANNUAL_REPORT_RESOURCES: ResourceItem[] = [
  {
    href: ANNUAL_REPORT_TECHNICAL_ASSISTANCE_FORM_URL,
    label: 'Annual Report Technical Assistance Request Form',
    description:
      'Submit a request for help with the annual reporting system or forms.',
  },
  {
    href: '/library/document/387eefc3bb6e4ad8b3bf7d85a2b3f514/latest',
    label: 'IRS-LC Worksheet',
    description:
      "Use this worksheet to collect the data that will be entered into your local chapter's online IRS-LC Form. Information may be entered online starting March 1. The completed online form must be approved by your chapter president by March 10.",
  },
];

const Resources: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Annual Reports Resources
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Links and forms to help with the annual reporting process.
      </Typography>

      <Card sx={{ maxWidth: 640 }}>
        <CardContent>
          <Stack spacing={2}>
            {ANNUAL_REPORT_RESOURCES.map((resource) => (
              <Box key={resource.href}>
                <Link
                  href={resource.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body1"
                >
                  {resource.label}
                </Link>
                {resource.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {resource.description}
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Resources;
